<template>
  <el-main class="el-mainContent"
  v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)">
    <p class="el-divider-header smallHeader">{{$t('cache_manage')}}</p>
    <span class="spanText">{{$t('clean_cache')}}</span> 
    <el-button type="primary" plain @click="clearConfig" size="small">{{$t('clearConfig')}}</el-button>
    <p class="el-divider-header smallHeader">{{$t('data_manage')}}</p>
    <span class="spanText">{{$t('clean_redundant')}}</span>
    <el-form
    >
      <el-form-item :label="$t('select_soft')">
        <el-col :span="4">
          <el-select :placeholder="$t('placeholder_select')" v-model="customAppsId" size="small">
            <el-option
              :label="$t('all')"
              value="">
            </el-option>
            <el-option
              v-for="item in customApps.datas"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-button type="primary" plain @click="clearConfigId" size="small">{{$t('clearConfigId')}}</el-button>
        <el-button type="primary" plain @click="synchronization" size="small">{{$t('synchronization')}}</el-button>
        <el-button type="primary" plain @click="indexOptimization" size="small">{{$t('indexOptimization')}}</el-button>

      </el-form-item>
    </el-form> 
    
    
  </el-main>
</template>

<script>


export default {
  data(){
    return {
      customApps:[],
      customAppsId:"",
      loading:false,
      loadingText:'正在优化中'
    }
  },
  computed:{
  },
  created() {
    this.$api.getCustomApps(
      {
        onSucess: resp => {
          this.customApps = resp.data.data;
        }
      }
    );
  },
  methods: {
    /**清除缓存数据 
     * */ 
    clearConfig(){
      this.$api.clearConfig(
        {
          onSucess: resp => {
            if(resp.data.errcode==0){
              this.loading=true;
              this.loadingText='正在清除中'
              this.getClearConfigState();
            }
            
          }
        }
      );
    },
    /**定期获取清除缓存数据 的状态
     * */ 
    getClearConfigState(){
      let timer = setInterval(()=>{
        this.$api.getClearConfigState(
          {
            onSucess: resp => {
              if(resp.data.data!='正在清除中'){
                this.loading=false;
                this.$message({
                  showClose: true,
                  message: "清除成功!",
                  type: "success"
                });
                clearInterval(timer)
              }
            }
          }
        );
      },1000)
    },
    clearConfigId(){
      this.$api.clearConfigId(this.customAppsId,
        {
          onSucess: resp => {
            if(resp.data.errcode==0){
              if(resp.data.data.indexOf("成功")!=-1){
                this.$message({
                  showClose: true,
                  message: resp.data.data,
                  type: "success"
                });
              }else{
                this.$message({
                  showClose: true,
                  message: resp.data.data,
                  type: "error"
                });
              }
              
            }
            
          }
        }
      );
    },
    /**
     * 同步数据表单
     */
    synchronization(){
      if(this.customAppsId==""){
        this.$message({
          showClose: true,
          message: "请选择软件!",
          type: "error"
        });
        return false;
      }
      
      this.$api.synchronization(this.customAppsId,
        {
          onSucess: resp => {
            if(resp.data.errcode==0){
              this.loading=true;
              this.loadingText='正在同步中'
              this.getSynchronizationState();
            }else{
              this.$message({
                showClose: true,
                message: "同步失败!",
                type: "error"
              });
            }
            
          }
        }
      );
    },
    /**
     * 获取同步数据表单状态
     */
    getSynchronizationState(){
      let timer = setInterval(()=>{

        this.$api.getSynchronizationState(this.customAppsId,
          {
            onSucess: resp => {
              if(resp.data.data!='正在同步中'){
                this.loading=false;
                this.$message({
                  showClose: true,
                  message: "同步成功!",
                  type: "success"
                });
                clearInterval(timer)
              }
              
            }
          }
        );
      },1000);
    },
    indexOptimization(){
      if(this.customAppsId==""){
        this.$message({
          showClose: true,
          message: "请选择软件!",
          type: "error"
        });
        return false;
      }
      this.loading=true;
      this.loadingText='正在优化中'
      this.$api.indexOptimization(this.customAppsId,
        {
          onSucess: resp => {
            this.loading=false;
            if(resp.data.errcode==0){
              if(resp.data.errcode==0){
                this.$message({
                  showClose: true,
                  message: resp.data.data,
                  type: "success"
                });
              }else{
                this.$message({
                  showClose: true,
                  message: resp.data.data,
                  type: "error"
                });
              }
              
            }
            
          }
        }
      );
    }
  },
};
</script>
<style lang="scss" scoped>

</style>